import React from "react";
import { Form, FloatingLabel } from "react-bootstrap";

interface NewsMediaFormProps {
  year: string;
  artist: string;
  category: string;
  title: string;
  media: string;
  datePosted: string;
  link: string;
  thumbnail: File | null;
  thumbnail_name?: string;
  onYearChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onArtistChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCategoryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMediaChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDatePostedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLinkChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onThumbnailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function NewsMediaForm({
  year,
  artist,
  category,
  title,
  media,
  datePosted,
  link,
  thumbnail,
  thumbnail_name,
  onYearChange,
  onArtistChange,
  onCategoryChange,
  onTitleChange,
  onMediaChange,
  onDatePostedChange,
  onLinkChange,
  onThumbnailChange,
}: NewsMediaFormProps) {
  return (
    <>
      <Form.Group className="mb-3" controlId="formYear">
        <label className="text-sm mb-2">Year</label>
        <FloatingLabel controlId="floatingInput" label="Year" className="mb-3">
          <Form.Control
            type="text"
            placeholder="Year"
            value={year}
            onChange={onYearChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formArtist">
        <label className="text-sm mb-2">Artist</label>
        <FloatingLabel
          controlId="floatingInput"
          label="Artist"
          className="mb-3"
        >
          <Form.Control
            type="text"
            placeholder="Artist"
            value={artist}
            onChange={onArtistChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formCategory">
        <label className="text-sm mb-2">Category</label>
        <FloatingLabel
          controlId="floatingInput"
          label="Category"
          className="mb-3"
        >
          <Form.Control
            type="text"
            placeholder="Category"
            value={category}
            onChange={onCategoryChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formTitle">
        <label className="text-sm mb-2">Title</label>
        <FloatingLabel controlId="floatingInput" label="Title" className="mb-3">
          <Form.Control
            type="text"
            placeholder="Title"
            value={title}
            onChange={onTitleChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formMedia">
        <label className="text-sm mb-2">Media</label>
        <FloatingLabel controlId="floatingInput" label="Media" className="mb-3">
          <Form.Control
            type="text"
            placeholder="Media"
            value={media}
            onChange={onMediaChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formDatePosted">
        <label className="text-sm mb-2">Date Posted</label>
        <FloatingLabel
          controlId="floatingInput"
          label="Date Posted"
          className="mb-3"
        >
          <Form.Control
            type="date"
            placeholder="Date Posted"
            value={datePosted}
            onChange={onDatePostedChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formLink">
        <label className="text-sm mb-2">Link</label>
        <FloatingLabel controlId="floatingInput" label="Link" className="mb-3">
          <Form.Control
            type="text"
            placeholder="Link"
            value={link}
            onChange={onLinkChange}
          />
        </FloatingLabel>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formThumbnail">
        {thumbnail_name && (
          <Form.Text className="text-xsm text-muted d-block">
            Server Thumbnail Image
          </Form.Text>
        )}
        <Form.Text className="text-black d-block pb-3 hover:text-red-500">
          {thumbnail_name ? (
            <a
              href={`http://127.0.0.1:8000/storage/${thumbnail_name}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {thumbnail_name}
            </a>
          ) : (
            "No Uploaded files on server"
          )}
        </Form.Text>
        <Form.Label className="text-sm mb-2">Thumbnail Image</Form.Label>
        <Form.Text className="text-muted d-block">Max Size: 2mb</Form.Text>
        <Form.Control type="file" onChange={onThumbnailChange} />
      </Form.Group>
    </>
  );
}
